"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _PaperModule = _interopRequireDefault(require("./Paper.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Класс для корректной работы с Autosuggest


var Paper = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classNameProp = props.className,
      ComponentProp = props.component,
      elevation = props.elevation,
      other = _objectWithoutProperties(props, ["className", "component", "elevation"]);

  var className = (0, _clsx["default"])(_PaperModule["default"].shadow, _PaperModule["default"]["shadow".concat(elevation >= 0 ? elevation : 0)], classNameProp);
  return /*#__PURE__*/_react["default"].createElement(ComponentProp, _extends({
    className: className,
    ref: ref
  }, other));
});

Paper.propTypes = {
  /**
     * @ignore
     */
  children: _propTypes["default"].node,

  /**
     * Useful to extend the style applied to components.
     */
  // Classes: PropTypes.object.isRequired,

  /**
     * @ignore
     */
  className: _propTypes["default"].string,

  /**
     * The component used for the root node.
     * Either a string to use a DOM element or a component.
     */
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),

  /**
     * Shadow depth, corresponds to `dp` in the spec.
     * It's accepting values between 0 and 24 inclusive.
     */
  elevation: _propTypes["default"].number,

  /**
     * If `true`, rounded corners are disabled.
     */
  square: _propTypes["default"].bool
};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: true
};
var _default = Paper;
exports["default"] = _default;